import React from 'react';

const SkeletonList = ({ rows = 6 }) => (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {Array.from({ length: rows }).map((_, idx) => (
            <div key={idx} className="rounded-2xl border border-slate-200 bg-white p-4 animate-pulse space-y-3">
                <div className="h-4 w-1/2 bg-slate-200 rounded" />
                <div className="h-3 w-full bg-slate-100 rounded" />
                <div className="h-3 w-3/4 bg-slate-100 rounded" />
                <div className="h-3 w-2/3 bg-slate-100 rounded" />
            </div>
        ))}
    </div>
);

export default SkeletonList;
